(()=>{
  const cleanSubscriptionCopy=()=>{
    document.querySelectorAll('.sensei-subscription-builder__option-badge').forEach(node=>{
      const text=node.textContent.trim();
      if(text==='SAVE 7% · MOCK') node.textContent='SAVE 7%';
      if(text==='BEST VALUE · MOCK') node.textContent='SAVE 14%';
    });
  };
  const initHomeCoffeeRail=()=>{
    const rail=document.querySelector('[data-s150-home-coffee-rail]');
    if(!rail)return;
    const prev=document.querySelector('[data-s150-home-rail-prev]');
    const next=document.querySelector('[data-s150-home-rail-next]');
    const item=()=>rail.querySelector('.home-coffee-item');
    const step=()=>{
      const node=item();
      if(!node)return rail.clientWidth;
      const styles=getComputedStyle(rail);
      const gap=parseFloat(styles.columnGap||styles.gap||'0')||0;
      return node.getBoundingClientRect().width+gap;
    };
    const update=()=>{
      const max=Math.max(0,rail.scrollWidth-rail.clientWidth-2);
      if(prev)prev.disabled=rail.scrollLeft<=2;
      if(next)next.disabled=rail.scrollLeft>=max;
    };
    prev?.addEventListener('click',()=>rail.scrollBy({left:-step(),behavior:'smooth'}));
    next?.addEventListener('click',()=>rail.scrollBy({left:step(),behavior:'smooth'}));
    rail.addEventListener('scroll',()=>requestAnimationFrame(update),{passive:true});
    window.addEventListener('resize',update,{passive:true});
    update();
  };
  const start=()=>{
    cleanSubscriptionCopy();
    initHomeCoffeeRail();
    if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    const nodes=[...document.querySelectorAll('[data-s150-reveal]')];
    if(!nodes.length)return;
    document.documentElement.classList.add('s150-motion-ready');
    const observer=new IntersectionObserver(entries=>{
      entries.forEach(entry=>{
        if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target);}
      });
    },{rootMargin:'0px 0px -8% 0px',threshold:.08});
    nodes.forEach(node=>observer.observe(node));
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
